import Image from "next/image";
import {Link} from "@/i18n/routing";
import {useTranslations} from 'next-intl';
import {ProductTag, ProductTagColors} from '@/libs/constants/common.constants';
import ProductCardViewPort from '@/components/shared/cards/ProductCardViewPort';
import ProductPrice from '@/components/shared/cards/ProductPrice';


export default function ProductCardPrimary({ product, isMobile, clientType }) {
  const t = useTranslations('catalog');
  
  return (
    <div className="ltn__product-item ltn__product-item-3 text-center">
      <Link href={`/products/${product.alt}`}>
        <div className="product-img">
          <Image
              src={product.coverImage}
              alt={product.id}
              width={1000}
              height={1000}
              loading="lazy"
              style={{aspectRatio: 1, objectFit: 'cover', height: 'auto'}}
          />
          {
            product.tag ? (
                <div className={`product-badge pb-${ProductTagColors[product.tag]}`}>
                  <ul>
                    <li className="sale-badge">
                      {t(`productTags.${product.tag}`)}
                      {product.discount > 0 && product.tag === ProductTag.SALE ? <span>{` -${product.discount * 100}%`}</span> : ''}
                    </li>
                  </ul>
                </div>
            ) : ''
          }
          {!isMobile ? <ProductCardViewPort product={product}/> : ''}
        </div>
      </Link>
      <div className="product-info">
        {
          product.reviewComputed ? (
              <div className="product-ratting" title={product.reviewComputed.average}>
                <ul>
                  {
                    product.reviewComputed.stars.map((icon, i) => (
                        <li key={i}>
                          <i className={icon}></i>
                        </li>
                    ))
                  }
                </ul>
              </div>
          ) : ''
        }
        {
            product.brand?.title ? (
                <h3 className="product-brand">
                  {product.brand?.title}
                </h3>
            ) : ''
        }
        <h2 className="product-title">
          <Link href={`/products/${product.alt}`}>{product.title}</Link>
        </h2>
        <ProductPrice
            price={product.price}
            clientType={clientType}
        />
        { isMobile ? <ProductCardViewPort product={product} isMobile={isMobile}/> : '' }
      </div>
    </div>
  );
};
